<template>
  <div>
    <vue-qrcode v-if="targetText" :value="targetText" :options="option" tag="img"></vue-qrcode>
    <div class="pl-5 pb-5">
      {{targetText}}
    </div>
    <div class="pl-5">
      右クリック - 画像の保存 でダウンロード可能（ポスターなどに利用してください）<br>
    </div>
  </div>
</template>

<script>

//ヘッダーを削除＆調整

import project from "../project.js";
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  name: "viewqr",
  components: {
    VueQrcode
  },  
  mounted: function() {
    let val = project.GetUrlVars();

    let qr = val["qr"];

    this.targetText = qr;
  },
  data: function() {
    return {
      targetText: "",
      option: {
        errorCorrectionLevel: "M",
        maskPattern: 0,
        margin: 10,
        scale: 2,
        width: 300,
        color: {
          dark: "#000000FF",
          light: "#FFFFFFFF",
        }
      }      
    };
  },
  methods: {

  },


  
};
</script>